import React, { createContext, useContext } from "react";
import { PresentationMode } from "../utils/presentation";

const PresentationModeContext = createContext<PresentationMode>("classic");

interface PresentationModeProviderProps {
  mode: PresentationMode;
  children: React.ReactNode;
}

export function PresentationModeProvider({ mode, children }: PresentationModeProviderProps) {
  return (
    <PresentationModeContext.Provider value={mode}>
      {children}
    </PresentationModeContext.Provider>
  );
}

export function usePresentationMode(): PresentationMode {
  return useContext(PresentationModeContext);
}
